<template>
  <div class="loading-sso-login">
    <div class="loader-wrapper">
      <div class="loader-ring" />
      <img
        src="@/assets/images/icons/seedz-logo-loading.svg"
        alt="Seedz"
        class="seedz-logo"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSsoLogin',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="stylus">
.loading-sso-login
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #ffffff
  display: flex
  align-items: center
  justify-content: center
  z-index: 99999

  .loader-wrapper
    position: relative
    display: flex
    align-items: center
    justify-content: center

  .loader-ring
    position: absolute
    width: 60px
    height: 60px
    border: 3px solid transparent
    border-right-color: #B6B8B9
    border-bottom-color: #B6B8B9
    border-left-color: #B6B8B9
    border-radius: 50%
    animation: spin 1s linear infinite

  .seedz-logo
    position: relative
    z-index: 1
    width: 24px
    height: 25px

@keyframes spin
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>
